import { BellOutlined, BellTwoTone, MenuFoldOutlined, MenuUnfoldOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { Badge, Button, Col, Flex, Row, Space, Typography } from 'antd';
import { Header } from 'antd/es/layout/layout';
import { useSelector } from 'react-redux';
import ProfileMenu from "./comp/ProfileMenu";
import DateRange from './comp/DateRange';
import SimpleDialogDemo from "./zerodhaDilogbox"
const Topbar = (props) => {

    const {Text} = Typography;
    const {collapsed, setCollapsed, screens, isDarkMode, toggleDarkMode} = props;
    const { userInfo } = useSelector((state) => state.auth);

// const userInfo  = true;

  return (
    <Header className={isDarkMode ? "site-layout-background-dark" :"site-layout-background"} style={{ padding: 0, boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.12)" }} >
        <Row style={{paddingLeft: "5px", paddingRight: "5px"}} >
            <Col flex="auto">
                <Button
                type="text"
                shape='circle'
                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined style={{color: "#2980b9"}} /> }
                onClick={() => setCollapsed(!collapsed)}
                style={{
                    fontSize: '16px',
                    marginLeft: "10px"
                }}
                />
                <Text type="secondary">Beta v1.0.1</Text>
            </Col>
            <Col flex="none">
            <Space size={"middle"}>  
                    <Button
                    type="text"
                    shape='circle'
                    icon={isDarkMode ? <SunOutlined /> : <MoonOutlined />}
                    onClick={() => toggleDarkMode()}
                    style={{
                        fontSize: '16px',
                        marginLeft: "10px",
                        display:  `${collapsed || screens.lg ? '' : 'none'}`
                    }}
                    />
                {screens.lg ? (
                <DateRange/>
                ):(
                    <></>
                )
                }
                <ProfileMenu collapsed={collapsed} screens={screens} userInfo={userInfo} />
            </Space>
            </Col>

      
        <Col flex="none">
      {screens.md && (
              <div
                style={{
                  marginRight: "15px",
                  display: "flex",
                  alignItems: "center",
                  paddingTop: screens.xs ? "0px" : "22px"
                }}
              >
            {/* <SimpleDialogDemo /> */}
          </div>
          )}
        </Col>
        </Row>
    </Header>
  )
}

export default Topbar
